// extracted by mini-css-extract-plugin
export default {"banner_wrapper":"BannerWebsite_banner_wrapper__wTdBg","banner_image":"BannerWebsite_banner_image__LfCjN"};